import {
  CONTINUE_TRANSACTION_SUCCESS,
  CONTINUE_TRANSACTION_FAILURE,
  TRANSACTION_STATUS_SUCCESS,
  TRANSACTION_STATUS_VERIFY,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_FAILURE,
  SET_PARAMS,
  SHOW_LOADING,
  HIDE_LOADING,
  SET_RFP_MONITORING,
  PUSH_ERROR_MESSAGE,
} from "./types";
import { INITIAL_STATE } from "./initialState";
import {
  CONTINUE_TRANSACTION_STATE,
  TRANSACTION_STATE,
} from "../../constants/status";
import { decodeURL } from "../../utils/common";

const pushErrorMessage = (state, action) => ({
  ...state,
  error: action.error,
});

const showLoading = (state) => ({
  ...state,
  isLoading: true,
});

const hideLoading = (state) => ({
  ...state,
  isLoading: false,
});

const appReducer = (state, action) => {
  state = state || INITIAL_STATE;
  switch (action.type) {
    case SHOW_LOADING:
      return showLoading(state);
    case SET_PARAMS:
      return {
        ...state,
        xAuthToken: action.code,
        merchantReturnUrl: action.merchantReturnUrl,
      }
    case HIDE_LOADING:
      return hideLoading(state);
    case SET_RFP_MONITORING:
      return {
        ...state,
        rfpMonitoring: true,
      };
    case PUSH_ERROR_MESSAGE:
      return pushErrorMessage(state, action);
    case CONTINUE_TRANSACTION_SUCCESS:
      return {
        ...state,
        continueTransaction: CONTINUE_TRANSACTION_STATE.GET_LINK_SUCCESS,
        redirectUrl: action.response,
      };
    case CONTINUE_TRANSACTION_FAILURE:
      return {
        ...state,
        continueTransaction: CONTINUE_TRANSACTION_STATE.FAILURE,
        error_code: action.error,
      };
    case TRANSACTION_STATUS_SUCCESS:
      return {
        ...state,
        transactionState: TRANSACTION_STATE.SUCCESS,
        bankLogoUrl: action.response.bankLogoUrl,
        merchantName: action.response.merchantName,
        merchantReturnUrl: action.response.merchantReturnUrl,
        transactionType: action.response.transactionType,
        transactionAmount: action.response.amount,
        paymentMethod: action.response.paymentMethod,
        bankName: action.response.bankName,
        accountNumberMask: action.response.accountNumberMask,
        accountSubType: action.response.accountSubType,
      };
    case TRANSACTION_STATUS_VERIFY:
      return {
        ...state,
        status: action.response.status,
        transactionState: action.response.status,
        merchantReturnUrl: decodeURL(action.response.merchantReturnUrl),
        transactionType: action.response.transactionType,
        merchantName: action.response.merchantName,
        transactionAmount: action.response.amount,
        paymentMethod: action.response.paymentMethod,
        redirectUrl: action.response.obvRedirectUrl
      };
    case TRANSACTION_STATUS_PENDING:
      return {
        ...state,
        status: TRANSACTION_STATE.PAYMENT_PROCESSING,
        transactionState: TRANSACTION_STATE.PAYMENT_PROCESSING,
        merchantReturnUrl: action.response.merchantReturnUrl,
        transactionType: action.response.transactionType,
        transactionAmount: action.response.amount,
        paymentMethod: action.response.paymentMethod,
        bankName: action.response.bankName,
        redirectUrl: action.response.obvRedirectUrl,
      };
    case TRANSACTION_STATUS_FAILURE:
      return {
        ...state,
        transactionState: TRANSACTION_STATE.FAILED,
        merchantName: action.response ? action.response.merchantName : state.merchantName,
        merchantReturnUrl: action.response && action.response.merchantReturnUrl ? action.response.merchantReturnUrl : state.merchantReturnUrl,
        transactionType: action.response?.transactionType,
        transactionAmount: action.response?.amount,
        transactionLimit: action.response?.limitAmount,
        error_code: action.response?.error || action.response?.errorCode,
        rfpError: action.response?.error,
        bankName: action.response?.bankName,
        accountNumberMask: action.response?.accountNumberMask,
        accountSubType: action.response?.accountSubType,
        displayDetailsLimit: action.response?.displayDetailsLimit
      };
    default:
      return state;
  }
};

export default appReducer;
